import * as React from 'react';

import { enumDocumentType } from '@rematter/frontend-lib-api-client';

import { useTranslations } from '~/modules/trade/i18n/useTranslations';
import { LoadRecord } from '~/modules/trade/types/load';
import { PrintableDocument } from '~/modules/trade/types/scaleTickets';

export const useOutboundPrintDocuments = (
  ticket: LoadRecord | null,
): PrintableDocument[] => {
  const t = useTranslations();

  return React.useMemo(
    () =>
      ticket
        ? [
            {
              label: t.transactionsView.actions.invoice,
              documentType: enumDocumentType.Invoice,
              loadId: ticket.id,
              invoiceId: ticket.billId ?? undefined,
              isDisabled: !ticket.billId,
              toastMessage: t.transactionsView.actions.printingInvoice,
            },
            {
              label: t.scaleTicketPro.documents.types.salesOrder,
              documentType: enumDocumentType.SalesOrder,
              loadId: ticket.id,
              salesOrderId: ticket.salesOrderId ?? undefined,
              isDisabled: !ticket.salesOrderId,
              toastMessage: t.transactionsView.actions.printingSalesOrder,
            },
            {
              label: t.transactionsView.actions.packingList,
              documentType: enumDocumentType.PackingList,
              loadId: ticket.id,
              toastMessage: t.transactionsView.actions.printingPackingList,
            },
            {
              label: t.transactionsView.actions.billOfLading,
              documentType: enumDocumentType.BillOfLading,
              loadId: ticket.id,
              toastMessage: t.transactionsView.actions.printingBillOfLading,
            },
            {
              label: t.scaleTicketPro.documents.types.fullPageWeightTicket,
              documentType: enumDocumentType.FullPageWeightTicket,
              loadId: ticket.id,
              toastMessage:
                t.transactionsView.actions.printingFullPageWeightTicket,
            },
            {
              label: t.scaleTicketPro.documents.types.fullPageScaleTicket,
              documentType: enumDocumentType.FullPageScaleTicket,
              loadId: ticket.id,
              toastMessage:
                t.transactionsView.actions.printingFullPageScaleTicket,
            },
          ]
        : [],
    [ticket?.id, ticket?.billId, ticket?.salesOrderId, t],
  );
};
